import ReminderDropdown from './ReminderDropdown';
import EmailReminderEntrySource from '../store/schema/EmailReminderEntrySource';
import { observer } from 'mobx-react-lite';
import generateBorderStyle from 'owa-calendar-forms-common/lib/utils/generateBorderStyle';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';
import * as React from 'react';

const styles = require('./ReminderDropdown.scss');
const classNames = require('classnames/bind').bind(styles);

export interface ReminderContainerProps {
    event: CalendarEvent;
    calendarColorScheme: ColorScheme;
    onReminderChanged: (reminderInMinutes: number) => void;
    entrySource: EmailReminderEntrySource;
    disabled?: boolean;
}

const EmailReminderContainer: React.SFC<ReminderContainerProps> = observer(props => {
    const { event, calendarColorScheme, onReminderChanged, entrySource, disabled } = props;
    const borderColorStyle = generateBorderStyle(calendarColorScheme);

    return (
        <div className={classNames(styles.reminderContainer, borderColorStyle.bottomBorder)}>
            <ReminderDropdown
                colorScheme={calendarColorScheme}
                entrySource={entrySource}
                event={event}
                onReminderChanged={onReminderChanged}
                selectedReminderTimeInMinutes={
                    event.ReminderIsSet ? event.ReminderMinutesBeforeStart : -1
                }
                disabled={disabled}
            />
        </div>
    );
});

export default EmailReminderContainer;
